import {z} from 'zod';

import i18n from '@dms/i18n';

export const formValuesSchema = z
  .object({
    enabled: z.boolean(),
    smsEnabled: z.boolean(),
    emailEnabled: z.boolean(),
    smsContextTemplateBody: z.string().nullable(),
    emailContextTemplateSubject: z.string().nullable(),
    emailContextTemplateBody: z.string().nullable(),
    emailCredentialsId: z.string().nullable(),
    additionalSettings: z.record(z.string(), z.any()).nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.enabled && data.smsEnabled && !data.smsContextTemplateBody) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['smsContextTemplateBody'],
        message: i18n.t('general.errors.mixed.required'),
      });
    }

    if (data.enabled && data.emailEnabled && !data.emailContextTemplateSubject) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['emailContextTemplateSubject'],
        message: i18n.t('general.errors.mixed.required'),
      });
    }

    if (data.enabled && data.emailEnabled && !data.emailContextTemplateBody) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['emailContextTemplateBody'],
        message: i18n.t('general.errors.mixed.required'),
      });
    }

    if (data.enabled && data.emailEnabled && !data.emailCredentialsId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['emailCredentialsId'],
        message: i18n.t('general.errors.mixed.required'),
      });
    }
  });

export const dynamicUiDefaultValuesKeys = [
  'enabled',
  'smsEnabled',
  'emailEnabled',
  'smsContextTemplateBody',
  'emailContextTemplateSubject',
  'emailContextTemplateBody',
  'emailCredentialsId',

  // not present in schema, but returned form general settings
  'emailContextTemplate',
  'smsContextTemplate',
];

export type FormValues = z.infer<typeof formValuesSchema>;
